import React, { useState } from "react";
import PropTypes from "prop-types";

import noop from "shared/util/noop";
import useBodyClassName from "routers/shared/hooks/useBodyClassName";

const Masthead = React.forwardRef(({ id, className, children, noClose, onClose }, ref) => {
	const [closed, setClosed] = useState(false);
	const closeHandler = () => {
		setClosed(true);
		onClose();
	};

	const bodyClassNames = closed ? [] : ["masthead-shown"];
	useBodyClassName(...bodyClassNames);

	if (closed) {
		return null;
	}

	return (
		<div ref={ref} id={id} className={`okmasthead ${className}`}>
			<div className="inner">
				{children}
			</div>
			{!noClose && (
				<button className="close" onClick={closeHandler}>
					<i className="icon i-close" />
				</button>
			)}
		</div >
	);
});

Masthead.propTypes = {
	id: PropTypes.string.isRequired,
	className: PropTypes.string,
	children: PropTypes.any.isRequired,
	noClose: PropTypes.bool,
	onClose: PropTypes.func,
};

Masthead.defaultProps = {
	className: "",
	noClose: false,
	onClose: noop,
};

export default Masthead;



// WEBPACK FOOTER //
// ./src/routers/Desktop/HeaderBanner/Masthead.jsx